import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { Profile } from "../models/profile";

@Injectable({ providedIn: "root" })
export class ProfilesService {
  constructor(private readonly http: HttpClient) {}

  loadProfiles(): Observable<Profile[]> {
    return this.http.get<Profile[]>("assets/profiles.json");
  }
}

